// @flow
import { color as color$ } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { CSSProperties } from 'react';
import { css } from 'styled-components';

export interface ColorProps {
    color: CSSProperties['color'];
}

export const color = (defaultValue: ColorProps['color'] = 'inherit'): any => css`
    & {
        color: ${color$('color', defaultValue)};
    }
`;

color.clean = (props): any => cleanProps(props, ['color']);
